export const RegistrationURLSteps = {
  termsCondition: 0,
  investorType: 1,
  personalInfo: 2,
  personalInfoExtra: 3,
  declaration: 4
};